import { render, staticRenderFns } from "./UsersTotal.vue?vue&type=template&id=c50cd51a"
import script from "./UsersTotal.vue?vue&type=script&lang=js"
export * from "./UsersTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports